export default class DashboardController {
  constructor() {

  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/dashboard/dashboard.controller.js
 **/